// extracted by mini-css-extract-plugin
export default {"keyboard":"keyboard_keyboard__1V2lB","keyboard__button":"keyboard_keyboard__button__YWwOY"};